var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavbarBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 27.5 34.421"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon ionic-ios-notifications-outline",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2925",
    d: "M16.634 29.861a1.114 1.114 0 00-1.093.878 2.156 2.156 0 01-.43.938 1.626 1.626 0 01-1.385.508 1.653 1.653 0 01-1.385-.508 2.156 2.156 0 01-.43-.938 1.114 1.114 0 00-1.093-.878 1.122 1.122 0 00-1.093 1.364 3.844 3.844 0 004 3.192 3.837 3.837 0 004-3.192 1.126 1.126 0 00-1.093-1.368z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2926",
    d: "M27.155 25.491c-1.325-1.746-3.93-2.77-3.93-10.59 0-8.031-3.546-11.253-6.85-12.031-.31-.077-.533-.181-.533-.508v-.245A2.11 2.11 0 0013.777 0h-.052a2.11 2.11 0 00-2.065 2.116v.254c0 .318-.224.43-.533.508-3.312.783-6.848 4-6.848 12.027 0 7.82-2.607 8.835-3.932 10.59a1.708 1.708 0 001.368 2.736h24.1a1.709 1.709 0 001.34-2.74zm-3.355.5H3.738a.377.377 0 01-.284-.628 10.422 10.422 0 001.807-2.873 19.5 19.5 0 001.23-7.588c0-3.209.6-5.721 1.8-7.467a5.52 5.52 0 013.329-2.374 3.015 3.015 0 001.6-.9.68.68 0 011.024-.017 3.117 3.117 0 001.617.921 5.52 5.52 0 013.329 2.374c1.2 1.746 1.8 4.258 1.8 7.467a19.5 19.5 0 001.23 7.588 10.541 10.541 0 001.85 2.916.356.356 0 01-.27.58z"
  }))));
}

export default SvgNavbarBell;